module.exports = __webpack_public_path__ + "img/certificate02-1-2.49e75242.jpg";